import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';
import React from 'react';

interface ResultSummaryCardProps {
  title: string;
  value: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  icon: LucideIcon;
  iconColor: string;
  valueColor: string;
  delay?: number;
}

export const ResultSummaryCard: React.FC<ResultSummaryCardProps> = ({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor,
  valueColor,
  delay = 0,
}) => {
  return (
    <motion.div
      className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ scale: 1.02 }}
    >
      <div className="flex items-center justify-center mb-4">
        <Icon size={24} style={{ color: iconColor }} className="mr-3" />
        <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
      </div>
      <div className="text-4xl font-bold mb-2" style={{ color: valueColor }}>
        {value}
      </div>
      {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
    </motion.div>
  );
};
